"use strict";

define(['./base', 'js-cookie'], function (Helper, cookies) {
  return Helper.extend({
    ui: {
      btn: '.js-close-message'
    },
    events: {
      'click @ui.btn': 'hideMessage'
    },
    options: {
      hiddenClass: 'is-hidden',
      animationDuration: 400
    },
    initialize: function initialize() {
      this.render();
    },
    render: function render() {
      if (!cookies.get(this.options.cookie)) {
        this.$el.removeClass(this.options.hiddenClass);
      }
    },
    hideMessage: function hideMessage() {
      cookies.set(this.options.cookie, true);
      this.$el.slideUp(this.options.animationDuration);
    }
  });
});